import LkTypeStorageExecutor
from '../../ko-component-myrgs-auth2-form/js/utils/lk-type-storage-executor';

export default function myRgsCleanupLocalStorage () {
	let lkTypeStorage = new LkTypeStorageExecutor();
	lkTypeStorage.clear();
}


